<template>
  <div class="basic_wrap">
    <div style="height: 100vh;">
      <div style="width: 100%;;height: 260px;background: linear-gradient(to bottom right, #6d28d9,#d946ef, #f472b6);padding-top: 14px;padding-bottom: 28px;padding-left: 14px;padding-right: 14px;">
        <div class="red_top_bg">
          <div
            style="margin-top: 8px;padding-left: 8px;padding-top: 8px;background-color: #4c1d9566;border-radius: 7px;height: 28px;width: 28px;align-items: center;justify-content: center;"
            @click="$router.back()"
          >
            <svg
              style="font-size: 12px;line-height: 18px;color:#fff;display:inline-block;height: 12px;"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="chevron-left"
              class="svg-inline--fa fa-chevron-left text-white"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            ><path
              fill="currentColor"
              d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
            /></svg>
          </div>
          <div
            class="big_tit"
            style="top:14px;"
          >
            <div style="padding-left: 4px;width: 100%;height: 28px;line-height: 28px;font-size: 14px;font-weight: 600;color:#fff">
              {{ $t('utils.kcode') }}
            </div>
            <div style="padding-left: 4px;width: 100%;height: 16px;line-height: 16px;font-size: 10px;font-weight: 400;color:#fff">
              {{ $t('utils.code1') }}
            </div>
          </div>
        </div>
        <div style="width: 100%;height: 156px;margin-top: 15px;background-color: #ffffff26;border-radius: 14px;display: flex;flex-direction: column;align-items: center;padding:20px">
          <div style="background-color: #fff3;border-radius: 7px;height: 70px;width: 70px;align-items: center;justify-content: center;padding:19px">
            <svg
              style="font-size: 32px;line-height: 18px;color:#fff;display:inline-block;height: 32px;"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="gift"
              class="svg-inline--fa fa-gift text-white text-4xl"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            ><path
              fill="currentColor"
              d="M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z"
            /></svg>
          </div>
          <div style="margin-top: 10px;width: 100%;height: 24px;font-size: 16px;font-weight: 600;color: #fff;line-height: 24px;text-align: center">
            {{ $t('utils.code2') }}
          </div>
          <div style="width: 100%;height: 18px;font-size: 12px;font-weight: 400;color: #fff;line-height: 18px;text-align: center">
            {{ $t('utils.code3') }}
          </div>
        </div>
      </div>
			
      <div style="width: 100%;margin-top: -14px;padding-bottom: 28px;padding-left: 14px;padding-right: 14px;">
        <div style="width: 100%;padding: 14px;height: 104px;background-color: rgb(30 41 59/1);border-radius: 14px;">
          <div style="height: 18px;line-height: 18px;font-size: 14px;color:#fff;font-weight: 600;">
            {{ $t('utils.kcode') }}
          </div>
          <div style="position: relative;;width:100%;margin-top: 10px;">
            <div style="position: absolute;;display:flex;align-items: center;margin-left: 6px;height: 50px;margin-right:6px">
              <div style="height: 35px;background-color: #4c1d9580;border-radius: 7px;padding: 16px;width:35px;margin-left: 10px;">
                <svg
                  style="font-size: 12px;line-height: 12px;color:#fff;display:inline-block;height: 12px;"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="tag"
                  class="svg-inline--fa fa-tag text-violet-400 text-sm"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                ><path
                  fill="currentColor"
                  d="M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                /></svg>
              </div>
            </div>
            <input
              v-model="code"
              placeholder="XXXX-XXXX-XXXX"
              maxlength="32"
              style="letter-spacing: .05em;color:#fff;padding-right:14px;padding-left:54px;padding-top:10px;padding-bottom: 10px;border:1px solid #e5e7eb;border-radius: 10px;height: 48px;display: block;width:100%"
            >
          </div>
        </div>
        <div style="margin-top:10px;width: 100%;padding:14px;width:100%;height:96px;background-color: #78350f33;border-radius: 1px solid #92400e66;border-radius: 14px;;">
          <div style="display: flex;align-items: flex-start;gap:10px;">
            <div style="display: flex;justify-content: center;flex-shrink: 0;;align-items: center;height: 28px;background-color: #78350f80;border-radius: 7px;padding: 8px;width:28px;">
              <svg
                style="font-size: 12px;line-height: 12px;color:rgb(251 191 36 /1);display:inline-block;height: 12px;"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="circle-info"
                class="svg-inline--fa fa-circle-info text-amber-400 text-sm"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              ><path
                fill="currentColor"
                d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
              /></svg>
            </div>
            <div>
              <p style="line-height:16px;margin-bottom: 3px;font-size: 12px;font-weight: 600;color:#fff"> 
                {{ $t('utils.code4') }}
              </p>
              <p style="line-height: 14px;margin-bottom: 3px;font-size: 10px;font-weight: 400;color:#fff">
                •{{ $t('utils.code5') }} 
              </p>
              <p style="line-height: 14px;margin-bottom: 3px;font-size: 10px;font-weight: 400;color:#fff">
                •{{ $t('utils.code6') }}
              </p>
              <p style="line-height: 14px;margin-bottom: 3px;font-size: 10px;font-weight: 400;color:#fff">
                •{{ $t('utils.code9') }}
              </p>
            </div>
          </div>
        </div>
				
        <div style="display: flex;gap:10px;margin-top:10px;height: 48px;">
          <div
            style="color:rgb(226 232 240/1);font-weight: 600;flex: 1 1 0%;border-radius: 14px;height: 48px;background-color: rgb(30 41 59 /1);line-height: 48px;text-align: center;font-size: 14px;font-weight: 600"
            @click="$router.back()"
          >
            {{ $t('utils.code7') }}
          </div>
          <div
            style="color:#fff;font-weight: 600;flex: 1 1 0%;border-radius: 14px;height: 48px;background:linear-gradient(to right, #6d28d9, #d946ef);line-height: 48px;text-align: center;font-size: 14px;font-weight: 600"
            @click="playcode()"
          >
            {{ $t('utils.code8') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch'
	import Clipboard from "v-clipboard";
	import {
		Icon,
		List,
		Empty,
		Popup
	} from "vant";

	Vue.use(Icon).use(Clipboard).use(List).use(Empty).use(Popup);
	export default {
		name: "Kode",
		data() {
			return {
				user_info: [],
				report: {
					"direct_count": 0,
					"indirect_count": 0,
					"income": 0,
					"income_to": 0,
					"income_ye": 0,
					"add_count": 0,
					"add_count_to": 0,
					"add_count_ye": 0
				},
				show_share: false,
				actives:1,
				empty: false,
				loading: false,
				finished: false,
				code:""
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#0F6EFF');
				plus.navigator.setStatusBarStyle('light');
			}
			this.$parent.footer('kode');
		},
		mounted() {
			this.start();
		},
		methods: {
			copy() {
				this.$toast(this.$t('recharge.copySuccess'));
			},playcode(){
				if(this.code.length<1){
					this.$toast(this.$t('utils.code10'));return false;
				}else{
					Fetch('/user/playcode', {
						code:this.code
					}).then(r => {
						if(r.code=='218'){
							this.$toast(this.$t(r.info));return false;
						}else{
							this.$toast(this.$t('utils.code11')+'Rp'+r.data.num);return false;
						}
					});
				}
				
			},
		
		}
	};
</script>

<style lang="less" scoped>
.basic_wrap {
		margin-bottom: 30px;
		background: #000;
	}
.top_header {
		justify-content: space-between;
		margin-bottom: 10px;
		background: #0F6EFF;
		width: 100%;
		margin: 0;
		border-radius: 0;
		color: #FFFFFF;
		height: 240px;
	}
</style>
